"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _default = exports.default = {
  props: ['buffer', 'message'],
  data() {
    return {
      pluginUiSections: _GlobalApi.default.singleton().messageInfoPlugins
    };
  },
  methods: {
    isSelf() {
      let user = this.$state.getUser(this.buffer.getNetwork().id, this.message.nick);
      return user && this.buffer.getNetwork().ircClient.user.nick === user.nick;
    },
    openQuery() {
      let network = this.buffer.getNetwork();
      let buffer = this.$state.addBuffer(network.id, this.message.nick);
      this.$state.setActiveBuffer(network.id, buffer.name);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageInfo"]
window._kiwi_exports.components.MessageInfo = exports.default ? exports.default : exports;
